import { DefaultOfficeAppId, OfficeActionType, } from '@office-start/action-types';
export var runUnregisteredAction = function (_a) {
    var actionExecutor = _a.actionExecutor, actionId = _a.actionId, executeAction = _a.executeAction, notificationOptions = _a.notificationOptions, instrumentationArea = _a.instrumentationArea, params = _a.params, _b = _a.actionMenuSource, actionMenuSource = _b === void 0 ? 'ContentActionsMenuItem' : _b;
    actionExecutor.executeActionAsync({
        type: OfficeActionType.unregistered,
        payload: {
            executeAction: executeAction,
            notificationOptions: notificationOptions,
        },
    }, {
        appId: DefaultOfficeAppId,
        actionId: actionId,
        referral: undefined,
        referralPlatform: undefined,
        sourceUXComponent: instrumentationArea,
        params: params,
        actionMenuSource: actionMenuSource,
    });
};
//# sourceMappingURL=runUnregisteredAction.js.map